const endPointURLs = {
  fakeApiEndpoint: () => '/todos',

  // IAM
  IAMAssignedPermission: () => '/user-iam/permission/assigned',

  // General
  General: () => '/master/v1/general',
  Search: () => '/onboarding/address/search',
  SearchCity: () => '/onboarding/address/search_city',

  // Employees
  Employee: () => '/agency/v1/employee',

  // Branch
  BranchList: () => '/agency/v1/branch',

  // Supervisors
  SupervisorPerformance: () => '/agency/v1/supervisor/performance',
  SPVList: () => '/agency/v1/spv/list',

  // ARE
  AREPerformance: () => '/agency/v1/are/performance',
  AREList: () => '/agency/v1/are/list',
  AREListBranch: () => '/agency/v1/are/list/branch',
  AREListTarget: () => '/agency/v1/are/list/target',
  ARETarget: () => '/agency/v1/are/target',
  AREBaselineTarget: () => '/agency/v1/are/baseline/target',
  AREHistoricalMonths: () => '/agency/v1/are/historical/months',
  AREHistoricalAverage: () => '/agency/v1/are/historical/average',

  // Agents
  AgentPerformance: () => '/agency/v1/agent/performance',
  AgentPerformanceMatrix: () => '/agency/v1/agent/performance/matrix',
  AgentPerformanceAll: () => '/agency/v1/agent/performance/agent/all',
  AgentList: () => 'agency/v1/agent/list',
  AgentActiveList: () => '/agency/v1/agent/active/list',
  AgentInactiveList: () => '/agency/v1/agent/inactive/list',
  AgentDetail: (agentMarketingId: string) =>
    `/agency/v1/agent/detail/${agentMarketingId}`,
  Agent: () => '/agency/v1/agent',
  AgentDeactivate: (agentMarketingId: string) =>
    `/agency/v1/agent/${agentMarketingId}/deactivate`,
  AgentPhoneNumber: (agentMarketingId: string) =>
    `/agency/v1/agent/${agentMarketingId}/phone_number`,
  AgentMaintainable: () => '/agency/v1/agent/maintainable',
  AgentReactivate: (agentMarketingId: string) =>
    `/agency/v1/agent/${agentMarketingId}/reactivate`,

  // Maintain Activity
  MaintainARESchedule: () => '/agency/v1/maintain/schedule',
  MaintainAssignment: () => '/agency/v1/maintain/assignment',
  MaintainReportDetail: () => '/agency/v1/maintain/report/detail',
  MaintainActivityReport: () => '/agency/v1/maintain/report/activity',

  // Recruit Activity
  RecruitAssignment: () => '/agency/v1/recruit/assignment',
  RecruitAll: () => '/agency/v2/recruit/all',
  RecruitWeeklyTarget: () => '/agency/v1/recruit/target',
  RecruitAgent: (agentRecruitId: string) =>
    `/agency/v1/recruit/agent/${agentRecruitId}`,
  RecruitAgents: () => '/agency/v1/recruit/agents',
  RecruitPerformanceArea: () => 'agency/v2/recruit/performance/area',
  RecruitReport: () => 'agency/v1/recruit/report',

  // Join Visit
  JoinVisitAreList: () => '/agency/v1/join-visit/are/list',
  JoinVisitReport: () => '/agency/v1/join-visit/report',
  JoinVisitQuestionList: () => '/agency/v1/join-visit/question',
  JoinVisitSummary: () => '/agency/v1/join-visit/summary',

  // Leads Tracker
  AREApplicationDetail: () => '/agency/v1/are/application/detail',
  SupervisorNotes: () => '/agency/v1/supervisor/application/agency/property',
  SupervisorNotesUpdate: (notesId: string) =>
    `/agency/v1/supervisor/application/agency/property/${notesId}`,
  LeadsTrackerList: () => 'agency/v1/are/application/prospect/list',

  // 1 on 1
  OneOnOneAREList: () => 'agency/v1/one-on-one/are/list',
  OneOnOneActionPlan: () => 'agency/v1/one-on-one/action-plan',
  OneOnOneActionPlanSpv: () => 'agency/v1/one-on-one/action-plan/spv',
  AverageMaintainRating: () => 'agency/v1/maintain/rating/average',
  AggregatedMaintainFeedback: () => 'agency/v1/maintain/feedback',
  ARERecruitPerformance: () => 'agency/v1/recruit/performance/are',

  // Notification
  Notification: () => 'agency/v1/notification',
  NotificationMarkAsRead: () => 'agency/v1/notification/mark-as-read',
  NotificationRead: (notificationId: string) =>
    `agency/v1/notification/${notificationId}/read`,

  // Weekly Meeting
  GroupMeetingReport: () => 'agency/v1/group-meeting/report',
  GroupMeetingDetail: (reportId: string) =>
    `agency/v1/group-meeting/report/${reportId}`,

  // KPI & Incentive
  IncentiveProgram: () => '/agency/v1/are/incentive/program',
  IncentiveType: () => '/agency/v1/are/incentive/type-project',
  IncentiveReport: () => '/agency/v1/are/incentive/report',

  // Agency News
  MediaBrochures: () => '/agency/v1/media/spv-brochures',
};

const HTTPEndPoints = new Proxy(endPointURLs, {
  get(target, name, receiver) {
    if (!Reflect.has(target, name)) {
      return '';
    }
    return (...params: string[]) =>
      Reflect.get(target, name, receiver)(...params);
  },
});

export default HTTPEndPoints;
